import { withInstall } from '@tav-ui/utils/with-install'
import EditorCustomUploadimageModal from './index.vue'

export * from './types'
export const TaEditorCustomUploadimageModal = withInstall(EditorCustomUploadimageModal)
export default TaEditorCustomUploadimageModal
